import toast from 'react-hot-toast';

const toastError = (err: any) => {
  toast.error(err.response.data?.errors[0]?.message || 'something went wrong');
};

export { toastError };
